import { render, staticRenderFns } from "./GerenciarNotificacoes.vue?vue&type=template&id=5c2d4362&scoped=true"
import script from "./GerenciarNotificacoes.vue?vue&type=script&lang=js"
export * from "./GerenciarNotificacoes.vue?vue&type=script&lang=js"
import style0 from "./GerenciarNotificacoes.vue?vue&type=style&index=0&id=5c2d4362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2d4362",
  null
  
)

export default component.exports